export default "__VITE_ASSET__DjlxR3af__"